import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { blogDataList } from '../Data/More_Data/blogData';

const Blog = () => {
  const [selectedCategory, setSelectedCategory] = useState("All");
  const allCategories = ["All"];
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

   useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const truncateText = (text, limit) => {
    return text.length > limit ? text.substring(0, limit) + '...' : text;
  };

  blogDataList.forEach((blog) => {
    if (blog.categories) {
      blog.categories.forEach((cat) => {
        if (!allCategories.includes(cat)) {
          allCategories.push(cat);
        }
      })
    };
  });

  const filteredblog = selectedCategory === "All"
    ? blogDataList
    : blogDataList.filter((blog) =>
      blog.categories?.includes(selectedCategory)
    );

  const buttonStyle = {
    padding: isMobile ? "4px 8px" : " 2px 16px 2px 16px",
    fontSize: isMobile ? "12px" : "16px",
    borderRadius: "25px",
    border: "1px solid #0d6efd",
    backgroundColor: "rgb(255, 255, 255)",
    color: "#18336c",
    cursor: "pointer",
  };

  const styles = {
    blogCard: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      height: '100%',
      padding: '16px',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
      borderRadius: '8px',
      backgroundColor: '#fff',
      transition: 'transform 0.3s, box-shadow 0.3s',
    },
    blogCardHover: {
      transform: 'translateY(-5px)',
      boxShadow: '0 8px 16px rgba(0, 0, 0, 0.2)',
    },
    blogImg: {
      width: '100%',
      maxHeight: '200px',
      objectFit: 'cover',
      borderRadius: '8px 8px 0 0',
    },
    blogContent: {
      padding: '16px',
    },
    blogMeta: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: '8px',
    },
    blogMetaLink: {
      color: '#555',
      textDecoration: 'none',
    },
    boxTitle: {
      fontSize: '1.2em',
      fontWeight: 'bold',
      marginBottom: '8px',
    },
    blogText: {
      flexGrow: 1,
      marginBottom: '16px',
    },
    blogBottom: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
    lineBtn: {
      display: 'flex',
      alignItems: 'center',
      textDecoration: 'none',
      color: '#18336c',
      fontWeight: 'bold',
    },
    arrowIcon: {
      marginLeft: '8px',
    },
   
  };

  return (
    <>
      <section
        className="bg-top-right overflow-hidden"
        id="blog-sec"
        style={{
          backgroundImage: `url('assets/img/bg/blog_bg_1.png')`,
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        <div className="container pt-5">
          <div className="title-area text-center" style={{marginBottom:"5px"}}>
            <span className="sub-title">LATEST BLOGS</span>
            <h2 className="sec-title">
              Get Every Single Update{" "}
              <span className="text-theme fw-normal">Blog</span>
            </h2>
          </div>
{        
          blogDataList.some(blog => blog.categories && blog.categories.length > 0) ?(
            <div style={{ display: "flex", flexDirection: isMobile ? "column" : "row", alignItems: "center", justifyContent: "center", gap:"10px"  }}>
            <p style={{ margin: "0px 0px 0px",display: "flex",alignItems: "center",fontSize: isMobile ? "14px" : "18px", color: "#18336c",}}><b>Filter By Categories :</b></p>
            <div  style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "center",
          gap: "6px",
        }}>
              {allCategories.map((categorie) => {
                return (
                  <button className="btn btn-outline-primary " style={buttonStyle}  onClick={() => setSelectedCategory(categorie)}>{categorie}</button>
                )
              })
              }
            </div>
            </div>
          ) : null
}

          <div className="row">
            {filteredblog.map((blog, index) => (
              <div
                className="col-12 col-md-12 col-lg-6 col-xl-4 p-4"
                key={index}
              >
                <div
                  className="blog-card gr-bg3"
                  style={styles.blogCard}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = "translateY(-5px)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = "none")
                  }
                  onMouseOver={(e) =>
                  (e.currentTarget.style.boxShadow =
                    "0 8px 16px rgba(0, 0, 0, 0.2)")
                  }
                  onMouseOut={(e) =>
                  (e.currentTarget.style.boxShadow =
                    "0 4px 8px rgba(0, 0, 0, 0.1)")
                  }
                >
                  <div className="blog-img">
                    <img
                      src={blog.imageSrc}
                      alt="blog"
                      loading="lazy"
                      style={styles.blogImg}
                    />
                  </div>
                  <div className="blog-content" style={styles.blogContent}>
                    <div className="blog-meta" style={styles.blogMeta}>
                      <a
                        href=""
                        onClick={(event) => event.preventDefault()}
                        style={styles.blogMetaLink}
                      >
                        <i className="fal fa-calendar-days"></i> {blog.date}
                      </a>
                      <a
                        href=""
                        onClick={(event) => event.preventDefault()}
                        style={styles.blogMetaLink}
                      >
                        <i className="fal fa-comments"></i> {blog.comments}
                      </a>
                    </div>
                    <h3 className="box-title" style={styles.boxTitle}>
                      <NavLink
                        to={blog.blogLink}
                        style={{ textDecoration: "none", color: "#000" }}
                      >
                        {truncateText(blog.title, 50)}
                      </NavLink>
                    </h3>
                    <p className="blog-text" style={styles.blogText}>
                      {truncateText(blog.description, 150)}
                    </p>
                    <div className="blog-bottom" style={styles.blogBottom}>
                      <NavLink
                        to={blog.blogLink}
                        className="line-btn"
                        style={styles.lineBtn}
                      >
                        Read More
                        <i
                          className="fas fa-arrow-right"
                          style={styles.arrowIcon}
                        ></i>
                      </NavLink>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default Blog;
